import React from 'react';
import { faCheckCircle, faScrewdriver } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    FormLabel, onFieldChange, onReactSelectChanged, ToastMessage, ValidationErrorMessage,
} from '../common/forms/FormElements';
import { Material } from './Material';
import CommonContext, { ApiRoutes } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { util } from '../Util';
import { handleFormSaveError } from '../common/forms/ValidationError';

export class MaterialForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        const stateBase = {
            material: this.props.material ?? new Material(),
            show: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onSubmit = this.onSubmit.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        this.populateState();
    }

    onChange = onFieldChange.bind(this);

    onClose(response) {
        this.setState({ show: false });
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    }

    onDelete = async (e) => {
        const { material } = this.state;
        const response = await util.fetch.delete(ApiRoutes.material.delete(material.id));
        if (response) this.onClose(response);
    };

    onSelectChange = onReactSelectChanged.bind(this);

    onSubmit = async (e) => {
        const { material } = this.state;

        // Clear any fluent api errors
        this.setState({ errors: {}, saving: true });

        // Is this POST or PUT?
        const url = material.id
            ? ApiRoutes.material.update(material.id)
            : ApiRoutes.material.create();
        const fetch_cte = material.id ? util.fetch.put : util.fetch.post;

        const response = await fetch_cte(url, material).catch(this.handleSaveError);

        if (response) {
            toast.success(<ToastMessage
                icon={faCheckCircle}
                header="Save Successful"
                message={`Material [${material.description}] saved.`}
            />);
            this.setState({ show: false, saving: false });
            this.context.setFormOpened(false);
            this.resetForm();
            this.context.setFormOpened(false);
            this.props.onSaveCallback(response);
        }
    };

    handleSaveError = handleFormSaveError.bind(this);

    open = async (id) => {
        this.resetForm();
        this.setState({ show: true, loading: true });
        this.context.setFormOpened(true);

        let [material] = await Promise.all([
            (id ? util.fetch.js(ApiRoutes.material.byId(id)) : new Material()),
        ]);

        this.setState({
            material,
            loading: false,
        });
    };

    async populateState() {
        this.setState((state) => ({
            loading: false,
        }));
    }

    resetForm() {
        this.setState({ formValidated: false });
    }

    render() {
        const {
            formValidated, validationMessage,
        } = this.state;
        const material = this.state.material;
        return (
            <SlideForm
                loading={this.state.loading}
                show={this.state.show}
                id="materialForm"
                formIcon={faScrewdriver}
                formTitle={!!parseInt(material.id ?? 0) > 0 ? 'Edit Material' : 'Add Material'}
                ref={this.formRef}
                setIsValidated={(value) => { this.setState({ formValidated: value }); }}
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                onSave={this.onSave}
                onDelete={this.onDelete}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                validationMessage={validationMessage}
            >

                <FormGroup>
                    <FormLabel
                        htmlFor="materialNumber"
                        text="Material Number"
                        required
                    />
                    <Input
                        id="description"
                        name="material.materialNumber"
                        value={material.materialNumber ?? ''}
                        onChange={this.onChange}
                        placeholder="Number"
                        type="text"
                        required
                    />
                    <ValidationErrorMessage>Material number is required.</ValidationErrorMessage>
                </FormGroup>

                <FormGroup>
                    <FormLabel
                        htmlFor="description"
                        text="Material Description"
                        required
                    />
                    <Input
                        id="description"
                        name="material.description"
                        value={material.description ?? ''}
                        onChange={this.onChange}
                        placeholder="Description"
                        type="text"
                        required
                    />
                    <ValidationErrorMessage>Material description is required.</ValidationErrorMessage>
                </FormGroup>

            </SlideForm>
        );
    }
}
